// app/javascript/controllers/experience_preview_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  verifyUrl(event) {
    const urlEl = this.element.querySelector('input[name*="[url]"]')
    const urlInput = urlEl.value?.trim()
    if (!urlInput) {
      event.preventDefault();
      return
    }

    const link = event.currentTarget
    const url = new URL(link.href)
    url.searchParams.set("url", urlInput)

    link.href = url.toString()
  }
}
